import { App } from '@pay24/pay'
import React from 'react'
import { createRoot } from 'react-dom/client'
import './hide-cra-error-overlay'

// noinspection JSCheckFunctionSignatures
createRoot(document.getElementById('root') as HTMLElement).render(<App />)
